import React, {useState, useEffect} from "react"
import axios from 'axios'

import {FormControl, InputLabel, Select, MenuItem, ListItemText, OutlinedInput, Checkbox} from '@material-ui/core';
import { useTranslation } from 'react-i18next';

export default function TechnicianFilter({
  setTecnicos,
  technicians,
  onTechnicianSelectionChange,
  loading,
  country,
  currentUser,
  selectedTechnicianIds
}) {
  const {t} = useTranslation();

  const MenuProps = {
    PaperProps: {
      style: {
        width: 300,
      },
    },
  };

  const [displayTechnicians, setDisplayTechnicians] = useState([])
  const [technicianIds, setTechnicianIds] = useState([])
  const [isInitialized, setIsInitialized] = useState(false)

  // Helper function to check if user is technician
  const isTechnician = () => {
    return currentUser && (
      currentUser.technician_id != null ||
      currentUser.get_roles_list?.includes('Técnico') ||
      currentUser.get_roles_names?.includes('Técnico')
    );
  };

  function handleTechnicianChange(event) {
    if (isTechnician()) return; // Prevent changes for technicians

    const {target: {value}} = event;
    if (value[value.length - 1] === "all") {
      const newIds = technicianIds.length === displayTechnicians.length ? [] : displayTechnicians.map(technician => technician.id);
      setTechnicianIds(newIds);
      onTechnicianSelectionChange(newIds);
      return;
    }
    setTechnicianIds(value);
    onTechnicianSelectionChange(value);
  }

  // Initialize technicians when technicians prop changes
  useEffect(() => {
    if (technicians && technicians.length > 0 && !isInitialized) {
      if (isTechnician()) {
        // For technicians, show only themselves
        const technicianId = currentUser.technician_id || currentUser.id;
        const technicianData = [{
          id: technicianId,
          user: {
            fullname: currentUser.fullname || `${currentUser.firstname} ${currentUser.lastname}`
          }
        }];
        setDisplayTechnicians(technicianData);
        setTecnicos(technicianData);
        const techIds = [technicianId];
        setTechnicianIds(techIds);
        // Call parent callback after state is set
        setTimeout(() => onTechnicianSelectionChange(techIds), 0);
      } else {
        // For non-technicians, show all technicians
        setDisplayTechnicians(technicians);
        setTecnicos(technicians);
        setTechnicianIds([]);
        // Don't call parent callback for non-technicians initially
      }
      setIsInitialized(true);
    }
  }, [technicians, currentUser, isInitialized]);

  // Reset initialization when country changes
  useEffect(() => {
    setIsInitialized(false);
    setTechnicianIds([]);
    setDisplayTechnicians([]);
  }, [country]);

  // Only sync with parent when selectedTechnicianIds actually changes and we're initialized
  useEffect(() => {
    if (isInitialized && JSON.stringify(selectedTechnicianIds) !== JSON.stringify(technicianIds)) {
      setTechnicianIds(selectedTechnicianIds);
    }
  }, [selectedTechnicianIds, isInitialized]);
  return (
    <FormControl variant="outlined" size="small">
      <InputLabel className="white-bg padding-sides-5">{t('technicians.selectTechnician')}</InputLabel>
      <Select
        multiple
        value={technicianIds}
        onChange={handleTechnicianChange}
        MenuProps={MenuProps}
        disabled={loading || isTechnician()} // Disable for technicians
        renderValue={(selected) => {
          if (isTechnician()) {
            // For technicians, just show their name
            return currentUser.fullname || `${currentUser.firstname} ${currentUser.lastname}`;
          }
          if (technicianIds.length !== displayTechnicians.length && technicianIds.length > 0) {
            return selected.map(selectedId => {
              return displayTechnicians.find(tecnico => selectedId == tecnico.id)?.user?.fullname
            }).join(', ')
          }
          return 'Todos'
        }}
        input={<OutlinedInput style={{height: '41px', width: '300px'}} label={t('technicians.techniciansTech')} />}
      >
        {!isTechnician() && (
          <MenuItem value="all" >
            <Checkbox color="primary" checked={technicianIds.length === displayTechnicians.length} />
            <ListItemText primary="Todos" />
          </MenuItem>
        )}

        {displayTechnicians.map((tecnico) => (
          <MenuItem key={tecnico.id} value={tecnico.id} >
            <Checkbox color="primary" checked={technicianIds.indexOf(tecnico.id) > -1} />
            <ListItemText primary={tecnico.user.fullname} />
          </MenuItem>
        ))
        }
      </Select>
    </FormControl>
  )
}
